<template>
  <el-main class="container">
    <div class="form-box">
      <el-form ref="queryFormRef" :model="queryForm" size="small" :inline="true">
        <el-form-item label="直播日期" prop="billDate.selected">
          <date-picker
            class="query_form_item"
            style="width: 240px"
            v-model="queryForm.billDate.selected"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </date-picker>
        </el-form-item>
        <!-- <el-form-item label="标题" prop="title.selected">
          <el-input style="width: 180px" placeholder="输入" v-model="queryForm.title.selected" clearable></el-input>
        </el-form-item> -->
        <el-form-item style="text-align: center">
          <el-button type="primary" @click="onSubmit">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="box" :style="{ height: boxHeight + 'px' }">
      <div class="left-box">
        <div class="table-box">
          <el-table :data="tableData" ref="table" size="mini" v-loading="tableIsLoading" border stripe height="100%" max-height="100%">
            <el-table-column type="index" align="center" width="40" :index="indexMethod"> </el-table-column>
            <el-table-column prop="title" align="center" label="标题"></el-table-column>
            <el-table-column prop="picUrl" align="center" label="图片地址">
              <template slot-scope="{ row }">
                <el-image style="width: 150px; height: 84px; display: block; margin: 0 auto" :src="row.picUrl" :preview-src-list="row.list" fit="cover"> </el-image>
              </template>
            </el-table-column>
            <el-table-column prop="broadcastDate" align="center" label="直播日期"> </el-table-column>
            <el-table-column prop="status" align="center" label="操作">
              <template slot-scope="{ row }">
                <el-button type="text" icon="el-icon-delete" class="delete" @click="deleteImg(row)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationArgs.page"
          :page-sizes="[10, 20, 100]"
          :page-size="paginationArgs.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
      <el-aside style="width: 35%; height: 100%">
        <el-form ref="addFormRef" :model="addForm" size="small" style="margin-top: 50px">
          <el-form-item prop="file">
            <el-upload
              class="upload-demo"
              :class="choosed ? 'none' : ''"
              list-type="picture-card"
              drag
              action="#"
              :auto-upload="false"
              :limit="1"
              :on-change="handleChange"
              :on-remove="handleRemove"
              ref="upload"
            >
              <template slot="default" v-if="!choosed">
                <p>将图片拖到此处或点击选择<br />仅支持上传jpg/png格式文件<br />单个文件不能超过500kb</p>
                <div class="upload-btn">点击上传</div>
              </template>
            </el-upload>
          </el-form-item>
          <el-form-item label="标题" prop="title" style="display: flex; justify-content: center">
            <el-input style="width: 250px" placeholder="请输入" v-model="addForm.title" clearable></el-input>
          </el-form-item>
          <el-form-item label="直播日期" prop="broadcastDate" style="display: flex; justify-content: center">
            <el-date-picker value-format="yyyy-MM-dd" type="date" v-model="addForm.broadcastDate"></el-date-picker>
          </el-form-item>
          <el-form-item style="text-align: center">
            <el-button @click="onAddReset">取消</el-button>
            <el-button type="primary" @click="onAddSubmit">确定</el-button>
          </el-form-item>
        </el-form>
      </el-aside>
    </div>
  </el-main>
</template>
<script>
import datePicker from "@/components/common/datePicker.vue"
import { pickerOptions, getAddDate, getNowFormatDate, toRawType } from "@/assets/js/common.js"
export default {
  name: "PosterManagement",
  components: {
    datePicker,
  },
  data() {
    let beginDate = getNowFormatDate()
    let endDate = getAddDate(20)
    return {
      queryForm: {
        billDate: { submitName: "billDate", selected: [beginDate, endDate] },
        // title: { submitName: "title", selected: "" },
      },
      pickerOptions: pickerOptions,
      tableData: [],
      tableIsLoading: false,
      paginationArgs: {
        page: 1,
        rows: 20,
      },
      total: 0,
      boxHeight: 0,
      addForm: {
        title: "",
        fill: {},
        broadcastDate: "",
      },
      choosed: false,
    }
  },
  created() {
    this.getTableList()
  },
  mounted() {
    this.onresize()
    window.addEventListener("resize", () => this.onresize(), false)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onresize(), false)
  },
  computed: {
    queryItem() {
      let tempItem = {}
      Object.values(this.queryForm).forEach((item) => {
        if (toRawType(item.selected) == "Array") {
          if (item.submitName == "billDate") {
            tempItem["beginSearchDate"] = item.selected[0] || ""
            tempItem["endSearchDate"] = item.selected[1] || ""
            return false
          }
          tempItem[item.submitName] = item.selected.map((i) => "'" + i.value + "'").join(",") || ""
        } else if (toRawType(item.selected) == "String") {
          tempItem[item.submitName] = item.selected || ""
        } else if (toRawType(item.selected) == "Object") {
          tempItem[item.submitName] = item.selected.value || ""
        }
      })
      return tempItem
    },
  },
  methods: {
    onresize() {
      // this.$refs.table.doLayout()
      this.boxHeight = parseInt(Number($(".container").height()) - Number($(".form-box").height()) - 6)
    },
    async getTableList() {
      this.tableIsLoading = true
      try {
        const { data: res } = await this.$http.post("/Account/monitorCenterEnterDefine/selectBroadcast.html", this.Qs.stringify({ ...this.queryItem, ...this.paginationArgs }))
        this.tableIsLoading = false
        // if (res.code != "success") return this.$message.error(res.message)
        // let { total, data } = JSON.parse(res)
        let data = JSON.parse(res.data)
        this.total = res.total
        this.tableData = data.map((item) => {
          item.list = []
          item.list.push(item.picUrl)
          return item
        })
      } catch (e) {
        console.log(e)
        this.tableIsLoading = false
      }
    },
    indexMethod(index) {
      return (this.paginationArgs.page - 1) * this.paginationArgs.rows + (index + 1)
    },
    // 监听pagesize的改变
    handleSizeChange(newSize) {
      this.paginationArgs.rows = newSize
      this.getTableList()
    },
    // 监听页码值的改变
    handleCurrentChange(newPage) {
      this.paginationArgs.page = newPage
      this.getTableList()
    },
    onSubmit() {
      this.paginationArgs.page = 1
      this.getTableList()
    },
    onReset() {
      this.$refs.queryFormRef.resetFields()
      this.paginationArgs.page = 1
      this.getTableList()
    },
    async deleteImg({ id }) {
      const confirmResult = await this.$confirm("此操作为删除操作, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err)
      if (confirmResult !== "confirm") return false
      const loading = this.$loading({
        lock: true,
        text: "删除中，请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      let url = "/Account/monitorCenterEnterDefine/updateBroadcast.html"
      const { data: res } = await this.$http.post(url, this.Qs.stringify({ id: id }))
      loading.close()
      if (res.code != "success") return this.$message.error(res.message)
      this.$message.success(res.message)
      this.getTableList()
    },
    handleChange(file) {
      const raw = file.raw
      const isJPG = raw.type === "image/jpeg" || raw.type === "image/png"
      const isLt2M = raw.size / 1024 < 500
      if (!isJPG) {
        this.$refs.upload.clearFiles()
        this.addForm.file = {}
        this.choosed = false
        return this.$message.error("上传图片只能是 JPG/PNG 格式!")
      }
      if (!isLt2M) {
        this.$refs.upload.clearFiles()
        this.addForm.file = {}
        this.choosed = false
        return this.$message.error("上传图片大小不能超过 500KB!")
      }
      this.addForm.file = file
      this.choosed = true
    },
    handleRemove(file) {
      this.addForm.file = {}
      this.choosed = false
    },
    async onAddSubmit() {
      if (!this.addForm.file || !this.addForm.file.url) return this.$message.error("请选择图片")
      if (!this.addForm.title) return this.$message.error("请填写标题")
      if (!this.addForm.broadcastDate) return this.$message.error("请选择直播日期")
      let obj = {
        title: this.addForm.title,
        broadcastDate: this.addForm.broadcastDate,
      }
      const loading = this.$loading({
        lock: true,
        text: "上传图片中，请耐心等待",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      var formData = new FormData()
      delete this.addForm.file.url.uid
      formData.append("file", this.addForm.file.raw)
      const { data: res } = await this.$http.post("/android/AcceptPictureServlet2", formData)
      if (res.code == "ERROR") {
        loading.close()
        return this.$message.error("图片上传错误")
      }
      obj.picUrl = res.result
      const { data: ret } = await this.$http.post("/Account/monitorCenterEnterDefine/addBroadcast.html", this.Qs.stringify(obj))
      loading.close()
      if (ret.code != "success") return this.$message.error(ret.message)
      this.$message.success(ret.message)
      this.paginationArgs.page = 1
      this.getTableList()
      this.onAddReset()
    },
    onAddReset() {
      this.$refs.addFormRef.resetFields()
      this.$refs.upload.clearFiles()
      this.addForm.file = {}
      this.choosed = false
    },
  },
}
</script>
<style lang="less" scoped>
.el-main {
  padding: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.form-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  .el-form-item {
    margin-bottom: 12px;
  }
}

.box {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;

  .left-box {
    flex: 1;
    height: 100%;

    .table-box {
      height: calc(100% - 32px);

      .el-table {
        flex: 1;

        ::v-deep .el-table__body {
          .row {
            p {
              display: flex;
              flex-direction: row;
              align-items: center;

              span {
                width: 62px;
                display: inline-block;
                text-align: left;
              }
            }
          }

          .button {
            width: 120px;
            height: 32px;
            text-align: center;
            color: #2a82e4;
            font-size: 14px;
            border-radius: 4px;
            border: 1px solid #2a82e4;
            line-height: 32px;
            margin: 0 auto;
            cursor: pointer;

            &.status {
              background-color: #2a82e4;
              color: #ffffff;
            }
          }

          .delete {
            font-size: 20px;
            padding: 0;
          }
        }
      }
    }
  }

  .el-aside {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    ::v-deep .el-upload {
      width: 360px;
      height: 340px;
      position: relative;
      border: none;

      .el-upload-dragger {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 340px;

        p {
          font-size: 12px;
          color: #a6a6a6;
          line-height: 28px;
        }

        .upload-btn {
          width: 120px;
          height: 32px;
          text-align: center;
          font-size: 14px;
          color: #ffffff;
          line-height: 32px;
          border-radius: 4px;
          background: #2a82e4;
          margin-top: 50px;
        }
      }
    }

    ::v-deep .el-upload-list {
      width: 360px;
      height: 340px;
      background-color: #fbfdff;
      border: 1px dashed #c0ccda;
      border-radius: 6px;
      box-sizing: border-box;
      cursor: pointer;
      line-height: 146px;
      vertical-align: top;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      z-index: 0;
      opacity: 0;

      li {
        display: block;
        margin: 0 auto;
        width: 200px;
        height: auto;
        border: none;

        img {
          width: 200px;
          height: auto;
          display: block;
        }
      }
    }

    .none {
      ::v-deep .el-upload--picture-card {
        z-index: 1;
      }

      ::v-deep .el-upload-list {
        z-index: 2;
        opacity: 1;
      }
    }
  }
}
</style>
